<div class="container-fluid" id="container-wrapper" *ngIf="userType=='Admin' || userType=='Counsellor'">
    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;padding-bottom: 3px;">
        <h1 class="h3 mb-0 text-gray-800">User Activity</h1>
    </div>
    <form [formGroup]="loginForm">
        <div class="row" style="padding-top: 10px;">

            <div class="col-md-2 col-sm-6 col-6">
                <div class="contain_card">
                    <mat-form-field>
                        <input style="cursor: pointer;" matInput [matDatepicker]="fromDateView" placeholder="From Date" (click)="fromDateView.open()" formControlName="fromDate" readonly required>
                        <mat-datepicker-toggle matSuffix [for]="fromDateView"></mat-datepicker-toggle>
                        <mat-datepicker #fromDateView disabled="false"></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-md-2 col-sm-6 col-6">
                <div class="contain_card">

                    <mat-form-field>
                        <input style="cursor: pointer;" matInput [matDatepicker]="toDateView" placeholder="To Date" (click)="toDateView.open()" formControlName="toDate" readonly required>
                        <mat-datepicker-toggle matSuffix [for]="toDateView"></mat-datepicker-toggle>
                        <mat-datepicker #toDateView disabled="false"></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-2 col-sm-12 col-12">

                <input type="button" class="block btn-info" value="View" style="width: 100%;" (click)="viewClick()">

            </div>
        </div>
    </form>
    <div class="table-responsive">
        <table class="table table-fixed">
            <thead>
                <tr>
                    <th scope="col" class="col-3">On Date</th>
                    <th scope="col" class="col-2">Action</th>
                    <th scope="col" class="col-5">Details</th>
                    <th scope="col" class="col-2">Status</th>
                </tr>
            </thead>
            <tbody id="myTable">
                <tr *ngFor="let data of pagedItems;i as index">
                    <td class="col-3">{{data.requestDateTime}}</td>
                    <td class="col-2">{{data.method}}</td>
                    <td class="col-5">{{data.operation}}</td>
                    <td class="col-2">{{data.status}}</td>
                </tr>

            </tbody>
        </table>
    </div>
    <div class="pagination-wrapper">
        <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(1)">First</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(pager.currentPage - 1)">Prev</a>
            </li>
            <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                <a (click)="setPage(page)">{{page}}</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.currentPage + 1)">Next</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.totalPages)">Last</a>
            </li>
        </ul>
    </div>
</div>